import { FavouriteLayoutModel } from 'app/types-shared';
import { LayoutType } from './types-store';
import { FavouriteDataModel } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';

export const ACTION = {
  CLEAR_SELECTION_REPORT_STATE: 'SELECTION_REPORT:CLEAR_STATE',
  REQUEST_LAYOUT_TYPES: 'SELECTION_REPORT:REQUEST_LAYOUT_TYPES',
  RESPONSE_LAYOUT_TYPES: 'SELECTION_REPORT:RESPONSE_LAYOUT_TYPES',
  FAVOURITE_NOT_VALID: 'SELECTION_REPORT:FAVOURITE_NOT_VALID',
  REQUEST_EXECUTE_FAVOURITE: 'SELECTION_REPORT:REQUEST_EXECUTE_FAVOURITE',
  RESPONSE_EXECUTE_FAVOURITE: 'SELECTION_REPORT:RESPONSE_EXECUTE_FAVOURITE',
  FAIL_EXECUTE_FAVOURITE: 'SELECTION_REPORT:FAIL_EXECUTE_FAVOURITE'
};

//#region General
export class ClearSelectionReportState {
  public type: string = ACTION.CLEAR_SELECTION_REPORT_STATE;
  constructor(public instanceKey: string) {}
}
export class RequestLayoutTypes {
  public type: string = ACTION.REQUEST_LAYOUT_TYPES;
  constructor(public instanceKey: string) {}
}
export class ResponseLayoutTypes {
  public type: string = ACTION.RESPONSE_LAYOUT_TYPES;
  constructor(public instanceKey: string, public data: LayoutType[]) { }
}
export class FavouriteNotValid {
  public type: string = ACTION.FAVOURITE_NOT_VALID;
  constructor(public instanceKey: string) {}
}
export class RequestExecuteFavourite {
  public type: string = ACTION.REQUEST_EXECUTE_FAVOURITE;
  constructor(public instanceKey: string) {}
}
export class ReceiveExecuteFavourite {
  public type: string = ACTION.RESPONSE_EXECUTE_FAVOURITE;
  constructor(
    public instanceKey: string, 
    public data: FavouriteDataModel, 
    public layout: FavouriteLayoutModel, 
    public requestId: number
  ) { }
}
export class FailExecuteFavourite {
  public type: string = ACTION.FAIL_EXECUTE_FAVOURITE;  

  constructor(public instanceKey: string, public errorsExecuteFailed: string[]) {}
}
//#endregion General
